import React from 'react'
import x2 from '../assets/X3.svg'
import { useNavigate } from 'react-router-dom';
import '../Component/css/NotFound.css';


const NotFound = () => {

    const navigate = useNavigate()

  return (
    <div className="home">
        <div className="notfound-selection">
            <div className="container">
                <div className='image'>
                    <img src={x2} alt="" />
                </div>

                <div onClick={() => navigate('/')} className="notfound">
                    <h4>Return to Home</h4> 
                    <div className="icon">
                        <i class="fas fa-angle-right"></i>
                        <i class="fas fa-angle-right"></i>
                    </div>
                </div>
            </div>
        </div>
    </div>  
  )
}

export default NotFound